export function hexToRgb(hex) {
    const normalized = hex.trim().replace(/^#/, '');
    if (/^[0-9a-fA-F]{3}$/.test(normalized)) {
        const [r, g, b] = normalized.split('').map((c) => parseInt(c + c, 16));
        return { r, g, b };
    }
    if (/^[0-9a-fA-F]{6}$/.test(normalized)) {
        const r = parseInt(normalized.slice(0, 2), 16);
        const g = parseInt(normalized.slice(2, 4), 16);
        const b = parseInt(normalized.slice(4, 6), 16);
        return { r, g, b };
    }
    return null;
}
export function getContrastTextColor([r, g, b]) {
    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
    return luminance > 140 ? 'black' : 'white';
}
export function isColorOscuro(color) {
    const rgb = hexToRgb(color);
    if (!rgb)
        return false;
    return getContrastTextColor([rgb.r, rgb.g, rgb.b]) === 'white';
}
export function getTextColorForBackground(color) {
    return isColorOscuro(color) ? 'white' : 'black';
}
